export const paths = {
  REPORT: `report`,
  REPORT_SUCCESS: `report-success`,
}

export const reportLinks = {
  reportLink: () => '',
  reportSuccessLink: () => `/${paths.REPORT_SUCCESS}`,
}
